export default __webpack_public_path__ + "static/media/hero-video-es.12f8c05d.webm";